import { Button, Grid, Stack, styled, SxProps, Typography, Box } from '@mui/material';
import { titleSX, buttonSX } from '@/components/blocks/DpLibrary/DpVideo/style/main';
import { combineSX } from '@/utils/combineSX';
import { Img } from '@/components/blocks/MaterialImage';
import { useIsMobile } from '@/data/hooks/useIsMobile';

const Video = styled('video')(({ theme }) => ({
	[theme.breakpoints.up('xs')]: {
		width: '100%',
	},
	[theme.breakpoints.up('sm')]: {
		width: '454px',
		height: '257px',
	},
}));

// eslint-disable-next-line complexity
export const DpCardDistribuidor = ({
	title,
	source,
	labelb,
	href,
	image,
	sxcustom,
	loading,
	priority,
}: {
	title: string;
	source: string;
	labelb: string;
	sxvideo?: SxProps;
	sxframe?: SxProps;
	sxpadding?: SxProps;
	href: string;
	image:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
	sxcustom?: SxProps;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
}) => {
	const isMobile = useIsMobile();
	const getImage = typeof image === 'string' ? image : isMobile ? image?.mobile : image?.desktop;

	return (
		<Grid direction="column" alignItems="center" sx={{ marginBottom: { xs: '20px', sm: '40px' } }}>
			<Img
				src={getImage}
				sx={combineSX([
					{ objectFit: 'cover', maxWidth: { xs: '100%', sm: '576px;' } },
					...(Array.isArray(sxcustom) ? sxcustom : [sxcustom]),
				])}
				loading={loading}
				priority={priority}
			/>
			<Box
				sx={{
					backgroundColor: '#ffffff',
					px: { xs: '0px', sm: '60px' },
					pt: { xs: '00px', sm: '20px' },
					pb: { xs: '20px', sm: '20px' },
				}}
			>
				<Typography component="h2" sx={titleSX}>
					{title}
				</Typography>
				<Video src={source} loop controls muted />
				<Stack sx={{ mt: '14px', mb: '20px', p: { xs: '0 28px', sm: '0px' } }}>
					<Button type="submit" variant="contained" sx={buttonSX} href={href}>
						{labelb}
					</Button>
				</Stack>
			</Box>
		</Grid>
	);
};
